import { render, staticRenderFns } from "./AulasLancadasAno.vue?vue&type=template&id=b35b2100&scoped=true"
import script from "./AulasLancadasAno.vue?vue&type=script&lang=js"
export * from "./AulasLancadasAno.vue?vue&type=script&lang=js"
import style0 from "./AulasLancadasAno.vue?vue&type=style&index=0&id=b35b2100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35b2100",
  null
  
)

export default component.exports